export default __webpack_public_path__ + "static/smiley-1210c2150582d27016f3f88576a0c129.png";